import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TransitionReportComponent } from './transition-report.component';

const routes: Routes = [{ path: ':childUuid', component: TransitionReportComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TransitionReportRoutingModule {}
